import React, { Component } from 'react';
import EWH from '../components/EWH';
//import { Link } from 'react-router-dom';
//import { Form } from 'react-bootstrap';
export class HomeElectionDay2025 extends Component {
	render() {
		return (
			<div className="App">
				<h2>Fascione HP primo turno</h2>
				<EWH id="ewh-fascione-comunali" repo='https://mediaset.withub.it/elezioni/withub/electionday-2025/comunali/fascione-hp.html?cid=ewh-fascione-comunali&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
				<h2>Fascione HP ballottaggio + referendum</h2>
				<EWH id="ewh-fascione-hp" repo='https://mediaset.withub.it/elezioni/withub/electionday-2025-06/fascione-hp.html?cid=ewh-fascione-hp&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
				<h2>Fascione ballottaggio</h2>
				<EWH id="ewh-fascione-ballottaggio" repo='https://mediaset.withub.it/elezioni/withub/electionday-2025-06/fascione-ballottaggio.html?cid=ewh-fascione-ballottaggio&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
				<h2>Fascione pagina referendum</h2>
				<EWH id="ewh-fascione-referendum" repo='https://mediaset.withub.it/elezioni/withub/electionday-2025/referendum/fascione-hp.html?cid=ewh-fascione-referendum&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
			</div>
		)
	}
}

export default HomeElectionDay2025
